import {isClient} from '@cred/shared/utils'
import {Base64} from 'js-base64'

export const populatedGtmDataLayer = data => {
  if (!isClient()) {
    return
  }

  // Create a custom GTM Data Layer array
  window.GoogleTagManager = []

  // Push all needed data to GTM Data Layer before Initialization
  window.GoogleTagManager.push(data)

  console.log('Data pushed to GTM DataLayer', data)
}

export const base64Encode = data => Base64.encode(data)

export const base64Decode = string => Base64.decode(string)

export const handleMetaQueryString = query => {
  let metaDecodeData

  if (query.meta) {
    // Decode Base64 string for meta query string
    metaDecodeData = base64Decode(query.meta)

    if (isClient()) {
      // Remove metaData from localStorage if existed
      window.localStorage.removeItem('foxSegmentData')

      // Set the metaData to the localStorage
      window.localStorage.setItem('foxSegmentData', metaDecodeData)
    }
  }

  return metaDecodeData
}

export const setVariablesToGtmDataLayer = metaDecodeData => {
  // Push meta data to GTM data layer if we are getting
  // Data from either URL query string or localStorage
  const foxSegmentData = metaDecodeData || window.localStorage.getItem('foxSegmentData')

  // Push meta data to GTM Data Layer if existed
  if (foxSegmentData) {
    populatedGtmDataLayer(JSON.parse(foxSegmentData))
  }
}
